import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { Vacancy } from '../types';

export const SHARE_WITH_HIRING_MANAGER = 'SHARE_WITH_HIRING_MANAGER';
export const SHARE_WITH_HIRING_MANAGER_SUCCESS = 'SHARE_WITH_HIRING_MANAGER_SUCCESS';

export interface ShareWithHiringManager {
    type: typeof SHARE_WITH_HIRING_MANAGER;
    payload: {
        request: AxiosRequestConfig;
        vacancyId: string;
    };
}

export interface ShareWithHiringManagerSuccess {
    type: typeof SHARE_WITH_HIRING_MANAGER_SUCCESS;
    payload: AxiosResponse<Vacancy>;
}

export const shareWithHiringManager = (vacancy: Vacancy): ShareWithHiringManager => {
    const link = vacancy._links!.put_invite_hiringmanager;
    const shareWithHiringManagerAction: ShareWithHiringManager = {
        type: SHARE_WITH_HIRING_MANAGER,
        payload: {
            request: {
                method: 'PUT',
                url: link.href,
            },
            vacancyId: vacancy.id,
        },
    };

    return shareWithHiringManagerAction;
};



// WEBPACK FOOTER //
// ./src/scenes/administrator/actions/share-with-hiring-managers-action.ts